import { render } from "./WebsiteInfrastructure.vue?vue&type=template&id=c2ca7a8a&scoped=true"
import script from "./WebsiteInfrastructure.vue?vue&type=script&lang=js"
export * from "./WebsiteInfrastructure.vue?vue&type=script&lang=js"

import "./WebsiteInfrastructure.vue?vue&type=style&index=0&id=c2ca7a8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ca7a8a"]])

export default __exports__